export default __webpack_public_path__ + "static/media/parent.d39182b6.svg";